export default "__VITE_ASSET__DmJtrRoc__"